/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Form } from 'semantic-ui-react';

const styles = {
    charsCount: {
        position: 'absolute',
        bottom: '15px',
        right: '15px',
        fontWeight: 'bold',
        color: '#000',
    },
};

class TextArea extends React.Component {
    render() {
        const { maxLength = false, value } = this.props;

        const currentLength = value && value.length ? value.length : 0;
        const charsCount = `${currentLength}/${maxLength}`;

        return (
            <Form.Field style={{ position: 'relative' }}>
                <Form.TextArea {...this.props} />
                <If condition={maxLength !== false}>
                    <span style={styles.charsCount}>{charsCount}</span>
                </If>
            </Form.Field>
        );
    }
}

export default TextArea;
